module.exports = __webpack_public_path__ + "img/walletBox21.39382efa.png";